import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import DynamicImage from '../dynamic-image'

const GridCard = ({image, onClick, title, variant}) => {
    const styles = useMultiStyleConfig('GridCard', {variant})
    return (
        <Flex {...styles.cardContainer} data-testid="grid-card" onClick={onClick}>
            <Flex {...styles.imgWrapper}>
                {image ? (
                    <DynamicImage src={image} imageProps={{...styles.tileImage}} width="100%" />
                ) : (
                    <DynamicImage
                        src={'https://dam.delonghigroup.com/800x640/assets/244948'} //placeholder in case of image undefined
                        imageProps={{...styles.tileImage}}
                        width="100%"
                    />
                )}
                <Box {...styles.gridCardOverlay} />
            </Flex>
            <Text
                {...styles.cardText}
                dangerouslySetInnerHTML={{
                    __html: title,
                }}
            />
        </Flex>
    )
}

GridCard.propTypes = {
    image: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string,
    variant: PropTypes.string,
}

export default GridCard
